<form [formGroup]="formService.form">
  <div class="relative helixbook-search mb-40">
    <input
      class="input input-search input-gray full-width"
      placeholder="Поиск в Helixbook"
      [formControl]="formService.form.controls.search" />
    <span *ngIf="formService.form.controls.search.value"
      class="icon icon-20 icon-cross-1 grey-700"
      (click)="clearSearch()">
    </span>
  </div>
</form>
